export default __webpack_public_path__ + "static/media/Blood_Boil_LE.9d3f05cf.jpg";